export default "__VITE_ASSET__pYiM_rHe__"